/**
 * An ability's real icon (story `q-charge-ability-anim-and-icon`, owner 2026-10-29: the "Ch" text
 * icon "means nothing"). Every ability slot on every bar — the desktop row, the compact phone row
 * and the T3 touch cluster — draws the served icon art, never the placeholder letter tile
 * (`IconGlyph`). The art is DATA: one SVG per ability id at `assets/ui/ability-icons/<id>.svg`,
 * L2 Soft Relief (AA-039, TGC-UI-010), and `basic-attack` for the F button. abilityIcon.test.ts
 * fails when an ability in content/progression/abilities has no icon file.
 *
 * The `pxl-glyph` class is kept on purpose: the AD-849 cooldown dim and stamina grey
 * (`ability-slot.css`) hang on it.
 */

/** Served directory of the ability icons, relative to the app base. */
export const ABILITY_ICON_DIR = 'assets/ui/ability-icons';

/** The icon id of the basic attack (the F / attack button), which is not a content ability. */
export const BASIC_ATTACK_ICON = 'basic-attack';

/** The served URL of an ability's icon. */
export function abilityIconUrl(abilityId: string): string {
  const base = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
  return `${base.replace(/\/+$/, '')}/${ABILITY_ICON_DIR}/${encodeURIComponent(abilityId)}.svg`;
}

export function AbilityIcon({
  abilityId,
  label,
  size = 28,
}: {
  abilityId: string;
  /** Accessible name (the slot's human label). */
  label: string;
  size?: number;
}): JSX.Element {
  return (
    <img
      className="pxl-glyph ability-icon"
      src={abilityIconUrl(abilityId)}
      alt={label}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      draggable={false}
      data-ability-icon={abilityId}
    />
  );
}
